import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "altText", "amount", "backgroundColorToken", "backgroundColorTokenArgs", "borderColorToken", "borderColorTokenArgs", "disabled", "fallbackCharacter", "hasBorder", "icon", "id", "imgResizeMode", "large", "loading", "medium", "size", "small", "textColorToken", "textColorTokenArgs", "source", "square", "onError", "testID", "UNSAFE_containerProps"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import { useDesignVersion } from '@bubble-ui/provider-design-version';
import Text from '@bubble-ui/primitive-text';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { useDesignContext } from '@klarna/designtokens';
import useStyleSheet from '@bubble-ui/hook-use-stylesheet';
import Loader from '@bubble-ui/molecule-loader';
import View from '@bubble-ui/primitive-view';
import { isNative } from '@bubble-ui/util-platform';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
import { defaultDesignTokens } from './defaultDesignTokens';
import { getDefaultStyleSheet } from './getDefaultStyleSheet';
import { AvatarImage } from './AvatarImage';
export var loaderSizes = {
  small: 36,
  medium: 46,
  regular: 56,
  large: 78
};
var Avatar = _ref => {
  var {
      accessibilityLabel,
      altText = 'Avatar',
      amount,
      backgroundColorToken,
      backgroundColorTokenArgs,
      borderColorToken,
      borderColorTokenArgs,
      disabled,
      fallbackCharacter,
      hasBorder = true,
      icon: Icon,
      id,
      imgResizeMode = 'contain',
      large,
      loading,
      medium,
      size,
      small,
      textColorToken,
      textColorTokenArgs,
      source,
      square,
      onError,
      testID,
      UNSAFE_containerProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'Avatar',
    props,
    useInstead: 'UNSAFE_containerProps',
    removalDate: 'v7.0.0'
  });
  var designVersion = useDesignVersion();
  var designContext = useDesignContext(defaultDesignTokens);
  var sizeArg = small ? 'small' : medium ? 'medium' : large ? 'large' : 'default';
  var avatarSize = size || designContext.get('avatar/image-size', {
    size: sizeArg
  }).pixelValue;
  var loaderStrokeWidth = avatarSize >= 72 ? 3 : avatarSize <= 32 ? 1 : 2;
  var loaderSpacing = 2;
  var loaderSize = avatarSize + 2 * loaderSpacing + 2 * loaderStrokeWidth;
  var loaderMargin = (avatarSize - loaderSize) / 2;
  var {
    amountBackgroundStyle,
    amountTextStyle,
    borderStyle,
    hasSourceStyle,
    iconViewStyle,
    imgStyle,
    textStyle,
    viewStyle
  } =
  // ⚠️ THIS COMPONENT SUPPORTS STYLE SHEET OVERRIDES ⚠️
  // Keep passing all props to the style sheet, even if we don't use them ourselves
  useStyleSheet(Avatar, getDefaultStyleSheet, _objectSpread(_objectSpread({}, props), {}, {
    accessibilityLabel,
    altText,
    avatarImageSize: avatarSize,
    backgroundColorToken,
    backgroundColorTokenArgs,
    borderColorToken,
    borderColorTokenArgs,
    designContext,
    designVersion,
    disabled,
    fallbackCharacter,
    hasBorder,
    icon: Icon,
    id,
    imgResizeMode,
    large,
    loading,
    medium,
    size,
    small,
    textColorToken,
    textColorTokenArgs,
    source,
    square,
    onError,
    testID,
    UNSAFE_containerProps
  }));
  return /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(View, _extends({
    id: id,
    testID: testID
  }, UNSAFE_containerProps, {
    accessibilityLabel: accessibilityLabel,
    style: viewStyle
  }, props), fallbackCharacter && !source && !Icon && /*#__PURE__*/React.createElement(Text, {
    style: textStyle
  }, fallbackCharacter.toUpperCase()), Icon && !source && /*#__PURE__*/React.createElement(View, {
    style: iconViewStyle
  }, /*#__PURE__*/React.createElement(Icon, null)), Boolean(source) && /*#__PURE__*/React.createElement(AvatarImage, {
    avatarImageSize: avatarSize,
    altText: altText,
    source: source,
    imgResizeMode: imgResizeMode,
    imgStyle: imgStyle,
    hasSourceStyle: hasSourceStyle,
    onError: onError
  }), (borderColorToken || hasBorder) && /*#__PURE__*/React.createElement(View, {
    style: _objectSpread(_objectSpread({}, !isNative ? hasSourceStyle : {}), borderStyle)
  }), amount && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(View, {
    style: amountBackgroundStyle
  }), /*#__PURE__*/React.createElement(Text, {
    style: amountTextStyle
  }, amount))), loading && /*#__PURE__*/React.createElement(View, {
    style: {
      marginBottom: loaderMargin,
      marginLeft: loaderMargin,
      marginRight: loaderMargin,
      marginTop: loaderMargin - avatarSize
    }
  }, /*#__PURE__*/React.createElement(Loader, {
    UNSAFE_size: loaderSize,
    UNSAFE_strokeWidth: loaderStrokeWidth
  })));
};
Avatar.displayName = 'Avatar';
export default withProvisionalOverrideFromContext(Avatar);
//# sourceMappingURL=index.js.map